export default {
  name: "range-in-table",
  components: {},
  props: [],
  data() {
    return {};
  },
  computed: {},
  beforeMount() {},
  mounted() {},
  methods: {}
};
